import { useEffect, useState } from "react";

import {
    createAdminUser,
    updateAdminUser,
} from "../../services/adminUserApi";

import { getRoles } from "../../services/roleApi";

function AdminUserForm({
    open,
    onClose,
    initialData,
    reload,
}) {

    const [roles, setRoles] = useState([]);

    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({

        fullName: "",

        email: "",

        phone: "",

        password: "",

        role: "",

        status: "Active",

        profileImage: null,

    });

    useEffect(() => {

        if (open) {

            loadRoles();

        }

    }, [open]);

    useEffect(() => {

        if (initialData) {

            setFormData({

                fullName: initialData.fullName || "",

                email: initialData.email || "",

                phone: initialData.phone || "",

                password: "",

                role: initialData.role?._id || "",

                status: initialData.status || "Active",

                profileImage: null,

            });

        } else {

            setFormData({

                fullName: "",

                email: "",

                phone: "",

                password: "",

                role: "",

                status: "Active",

                profileImage: null,

            });

        }

    }, [initialData]);

    const loadRoles = async () => {

        try {

            const res = await getRoles();

            setRoles(res.data);

        } catch (error) {

            console.error(error);

        }

    };

    const handleChange = (e) => {

        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

    };

    const handleImage = (e) => {

        setFormData((prev) => ({
            ...prev,
            profileImage: e.target.files[0],
        }));

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            setLoading(true);

            const data = new FormData();

            data.append("fullName", formData.fullName);
            data.append("email", formData.email);
            data.append("phone", formData.phone);
            data.append("role", formData.role);
            data.append("status", formData.status);

            if (formData.password) {

                data.append(
                    "password",
                    formData.password
                );

            }

            if (formData.profileImage) {

                data.append(
                    "profileImage",
                    formData.profileImage
                );

            }

            if (initialData) {

                await updateAdminUser(
                    initialData._id,
                    data
                );

            } else {

                await createAdminUser(data);

            }

            reload();

            onClose();

        } catch (error) {

            console.error(error);

            alert("Something went wrong.");

        } finally {

            setLoading(false);

        }

    };

    if (!open) return null;

    return (

        <div className="modal-overlay">

            <div className="admin-user-modal">

                <div className="modal-header">

                    <h2>

                        {initialData
                            ? "Edit Admin User"
                            : "Add Admin User"}

                    </h2>

                </div>

                <form onSubmit={handleSubmit}>

                    <div className="form-grid">

                        <div className="form-group">

                            <label>

                                Full Name

                            </label>

                            <input
                                type="text"
                                name="fullName"
                                value={formData.fullName}
                                onChange={handleChange}
                                required
                            />

                        </div>

                        <div className="form-group">

                            <label>

                                Email

                            </label>

                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />

                        </div>

                        <div className="form-group">

                            <label>

                                Phone

                            </label>

                            <input
                                type="text"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                            />

                        </div>

                        {!initialData && (

                            <div className="form-group">

                                <label>

                                    Password

                                </label>

                                <input
                                    type="password"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    required
                                />

                            </div>

                        )}

                        <div className="form-group">

                            <label>

                                Role

                            </label>

                            <select
                                name="role"
                                value={formData.role}
                                onChange={handleChange}
                                required
                            >

                                <option value="">

                                    Select Role

                                </option>

                                {roles.map((role) => (

                                    <option
                                        key={role._id}
                                        value={role._id}
                                    >

                                        {role.roleName}

                                    </option>

                                ))}

                            </select>

                        </div>

                        <div className="form-group">

                            <label>

                                Status

                            </label>

                            <select
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                            >

                                <option value="Active">

                                    Active

                                </option>

                                <option value="Inactive">

                                    Inactive

                                </option>

                            </select>

                        </div>

                        <div className="form-group">

                            <label>

                                Profile Image

                            </label>

                            <input
                                type="file"
                                accept="image/*"
                                onChange={handleImage}
                            />

                        </div>

                    </div>

                    <div className="modal-actions">

                        <button
                            type="button"
                            className="cancel-btn"
                            onClick={onClose}
                        >

                            Cancel

                        </button>

                        <button
                            type="submit"
                            className="save-btn"
                            disabled={loading}
                        >

                            {loading
                                ? "Saving..."
                                : initialData
                                ? "Update Admin"
                                : "Create Admin"}

                        </button>

                    </div>

                </form>

            </div>

        </div>

    );

}

export default AdminUserForm;